export enum TenantPermission {
  CancellationRequest = 'cancellationRequest',
  Claim = 'claim',
  Order = 'order',
}
